import type { Routes } from '@angular/router';

export const DOWNLOAD_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#modules/gallery/views/download-medias-and-folders/download-medias-and-folders.component').then(
                (m) => m.DownloadMediasAndFoldersComponent
            ),
    },
];
